<template>
	<el-dialog title="通知" :visible="visible" :close-on-click-modal="false" @open="open" @close="close" top="1vh">

		<!--TOOLBAR-->
		<el-row class="i-toolbar">
			<el-col :span="20">
				<el-button type="primary" @click="setting" size="small">全部已读</el-button>
			</el-col>
		</el-row>

		<el-table :data="table.datas">
			<el-table-column label="内容">
				<template slot-scope="{row}">
					<p :class="row.noticeState == 2 ? 'i-text--info' : ''">{{ row.content }}</p>
				</template>
			</el-table-column>
			<el-table-column label="时间" prop="_createTime" width="180" />
		</el-table>

		<!--PAGE-->
		<el-pagination
			background
			layout="prev, pager, next"
			:total="pagination.count"
			:page-size="pagination.size"
			:current-page="pagination.current"
			@current-change="currentChange"
		/>

	</el-dialog>
</template>
<script>
import {searchNotice, submitSettingNotice} from '@/api/notice'
import index from '@/mixins/index'
export default {
	name: 'NoticeIndex',
	mixins: [index],
	data() {
		return {
			mode: 'dialog',
			api: {
				search: searchNotice
			}
		}
	},
	methods: {
		setting() {
			submitSettingNotice().then(()=> {
				this.close()
			})
		}
	}
}
</script>